/**
 * When the page has a .gh-hero section:
 * - Add .gh-has-hero to body (for nav/logo styling)
 * - Toggle .gh-nav-at-top while the hero is at the top of the viewport
 *   (remove it after scrolling past the hero)
 */
function heroNavScroll() {
    const hero = document.querySelector('.gh-hero');
    if (!hero) return;

    // Home page with hero: mark that we have a hero and that nav starts "at top"
    document.body.classList.add('gh-has-hero', 'gh-nav-at-top');

    const navHeight = 100;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    document.body.classList.add('gh-nav-at-top');
                } else {
                    document.body.classList.remove('gh-nav-at-top');
                }
            });
        },
        {
            root: null,
            rootMargin: `-${navHeight/2}px 0px 0px 0px`,
            threshold: 0,
        }
    );

    observer.observe(hero);
}

export default heroNavScroll;
